import type { ReactElement, ReactNode } from "react";
import { Reiter } from "@kundeninfo/ui/me-design";
import { KiRegister } from "../../components/meHuellen.js";
import { LIQUIDITY_TEXT_WEB as T } from "./liquidityTexts.js";
import "./Liquidity.css";

const LIQUIDITY_PANEL = "finance-liquidity";

/**
 * DER BEREICH „FINANZEN“ (Empfehlung 591), Muster `PurchasingArea`: ein Navigationseintrag mit Reitern (`me-register`, Hausregel
 * „Reiter nach unten offen“). Heute steht dort nur „Liquidität“; „Erfolgsrechnung“ und Bankabruf kommen später dazu (Spec).
 */
export function FinanceArea(p: { children: ReactNode }): ReactElement {
  return (
    <div className="liq">
      <KiRegister className="liq__tabs" aria-label={T.areaFinance} aktiv={LIQUIDITY_PANEL}>
        <Reiter fuer={LIQUIDITY_PANEL} beschriftung={T.tabLiquidity} />
      </KiRegister>
      <div className="liq__panel" id={LIQUIDITY_PANEL} role="tabpanel" aria-label={T.tabLiquidity}>{p.children}</div>
    </div>
  );
}
